var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefrrelThree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 117,
    height: 102,
    viewBox: "0 0 117 102",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6983",
    "data-name": "Group 6983",
    transform: "translate(-93 -4468)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6982",
    "data-name": "Group 6982"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Polygon_1",
    "data-name": "Polygon 1",
    transform: "translate(93 4468)",
    fill: "#032058"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 79.06101226806641 101.5 L 37.93898391723633 101.5 C 35.38992691040039 101.5 32.87668609619141 100.8246459960938 30.67097091674805 99.54695892333984 C 28.46525764465332 98.26925659179688 26.62904357910156 96.42512512207031 25.3608570098877 94.21392822265625 L 4.713799953460693 58.21391296386719 C 3.456500053405762 56.02170181274414 2.79192852973938 53.52717208862305 2.79192852973938 51 C 2.79192852973938 48.47282791137695 3.456500053405762 45.97828674316406 4.713799953460693 43.78607177734375 L 25.3608570098877 7.786071300506592 C 26.62905693054199 5.57487154006958 28.46525764465332 3.730742931365967 30.67098617553711 2.45304274559021 C 32.87670135498047 1.175357103347778 35.38992691040039 0.5 37.93898391723633 0.5 L 79.06101226806641 0.5 C 81.61006927490234 0.5 84.12331390380859 1.175357103347778 86.32904052734375 2.45304274559021 C 88.53474426269531 3.730742931365967 90.37095642089844 5.57487154006958 91.63914489746094 7.786071300506592 L 112.2862014770508 43.78607177734375 C 113.5435028076172 45.97828674316406 114.2080841064453 48.47282791137695 114.2080841064453 51 C 114.2080841064453 53.52717208862305 113.5435028076172 56.02171325683594 112.2862014770508 58.21392822265625 L 91.63914489746094 94.21392822265625 C 90.37095642089844 96.42512512207031 88.53474426269531 98.26925659179688 86.32902526855469 99.54695892333984 C 84.12331390380859 100.8246459960938 81.61006927490234 101.5 79.06101226806641 101.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 37.93898773193359 1 C 35.47782897949219 1 33.05124664306641 1.652061462402344 30.92160034179688 2.885688781738281 C 28.79193878173828 4.119338989257812 27.01904296875 5.899879455566406 25.79458618164062 8.034812927246094 L 5.14752197265625 44.03481674194336 C 3.933586120605469 46.15144729614258 3.291923522949219 48.55997085571289 3.291923522949219 51 C 3.291923522949219 53.44002914428711 3.933570861816406 55.84853744506836 5.14752197265625 57.96516799926758 L 25.79458618164062 93.96517181396484 C 27.01904296875 96.10012054443359 28.79192352294922 97.88066101074219 30.92158508300781 99.11429595947266 C 33.05124664306641 100.3479385375977 35.47781372070312 101 37.93898773193359 101 L 79.06101989746094 101 C 81.52217102050781 101 83.94875335693359 100.3479385375977 86.07841491699219 99.11429595947266 C 88.20807647705078 97.88066101074219 89.98097229003906 96.10010528564453 91.20541381835938 93.96517181396484 L 111.8524627685547 57.96516799926758 C 113.0664138793945 55.84853744506836 113.7080764770508 53.44001388549805 113.7080764770508 51 C 113.7080764770508 48.55997085571289 113.0664138793945 46.15146255493164 111.8524627685547 44.03483200073242 L 91.20541381835938 8.034828186035156 C 89.98097229003906 5.899879455566406 88.20807647705078 4.119338989257812 86.07841491699219 2.885704040527344 C 83.94875335693359 1.652061462402344 81.52218627929688 1 79.06101989746094 1 L 37.93898773193359 1 M 37.93898773193359 0 L 79.06101989746094 0 C 84.43539428710938 0 89.39906311035156 2.875274658203125 92.0728759765625 7.537322998046875 L 112.7199249267578 43.53732299804688 C 115.3708038330078 48.15932464599609 115.3708038330078 53.84066009521484 112.7199249267578 58.46267700195312 L 92.0728759765625 94.46267700195312 C 89.39906311035156 99.12471008300781 84.43537902832031 102 79.06101989746094 102 L 37.93898773193359 102 C 32.56459808349609 102 27.60093688964844 99.12471008300781 24.9271240234375 94.46267700195312 L 4.280059814453125 58.46267700195312 C 1.629203796386719 53.84066009521484 1.629219055175781 48.15932464599609 4.280059814453125 43.53730773925781 L 24.9271240234375 7.537307739257812 C 27.6009521484375 2.875274658203125 32.56461334228516 0 37.93898773193359 0 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "pricing_3_",
    "data-name": "pricing (3)",
    transform: "translate(116 4483.786)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11869",
    "data-name": "Path 11869",
    d: "M61.262,23.126c0,2.507-4.063,4.192-4.96,6.375-.94,2.258.7,6.31-.994,8.017s-5.759.065-8.017.994c-2.183.908-3.868,4.96-6.375,4.96s-4.192-4.063-6.375-4.96c-2.258-.94-6.31.7-8.017-.994s-.065-5.759-.994-8.017c-.908-2.183-4.96-3.868-4.96-6.375s4.063-4.192,4.96-6.375c.94-2.258-.7-6.31.994-8.017s5.759-.065,8.017-.994c2.183-.908,3.868-4.96,6.375-4.96s4.192,4.063,6.375,4.96c2.258.94,6.31-.7,8.017.994s.065,5.759.994,8.017C57.21,18.945,61.262,20.619,61.262,23.126Z",
    transform: "translate(1.495)",
    fill: "#6e7fed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11870",
    "data-name": "Path 11870",
    d: "M55.919,16.375c-.94-2.258.7-6.31-.994-8.017a3.056,3.056,0,0,0-1.88-.767c.065.7.108,1.415.108,2.139A21.872,21.872,0,0,1,25.46,30.886c.054,2.215-.627,4.938.692,6.245,1.707,1.707,5.759.065,8.017.994,2.183.908,3.868,4.96,6.375,4.96s4.192-4.063,6.375-4.96c2.258-.94,6.31.7,8.017-.994s.065-5.759.994-8.017c.908-2.183,4.96-3.868,4.96-6.375s-4.063-4.182-4.97-6.364Z",
    transform: "translate(1.879 0.387)",
    fill: "#5f6fe7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6906",
    "data-name": "Group 6906",
    transform: "translate(2 40.987)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11871",
    "data-name": "Path 11871",
    d: "M28.257,53.867H42.563a4.508,4.508,0,0,0,4.517-3.609A4.338,4.338,0,0,0,42.8,45.191H34.934a9.138,9.138,0,0,1-5.694-2.042c-3.371-2.69-10.492-6.4-19.86-.313V60.113s5.111-.648,13.723,2.712a32.564,32.564,0,0,0,18.812,1.588,79.7,79.7,0,0,0,24.409-9.563,4.413,4.413,0,0,0-.238-7.628l-.032-.022a4.391,4.391,0,0,0-3.555-.259l-17.558,6.3",
    transform: "translate(-1.406 -38.027)",
    fill: "#ffbfad"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6904",
    "data-name": "Group 6904",
    transform: "translate(24.204 10.939)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11872",
    "data-name": "Path 11872",
    d: "M39.992,54.451H25.686a1.286,1.286,0,1,1,0-2.572H39.992a3.217,3.217,0,0,0,3.242-2.528,1.287,1.287,0,0,1,1.48-1.07,1.3,1.3,0,0,1,1.07,1.48A5.819,5.819,0,0,1,39.992,54.451Z",
    transform: "translate(-24.4 -48.263)",
    fill: "#f0a696"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6905",
    "data-name": "Group 6905",
    transform: "translate(7.963 11.14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11873",
    "data-name": "Path 11873",
    d: "M66.313,50.254A79.377,79.377,0,0,1,41.9,59.828a32.745,32.745,0,0,1-18.812-1.588C14.481,54.868,9.37,55.527,9.37,55.527V59.4s5.111-.648,13.723,2.712A32.564,32.564,0,0,0,41.9,63.7a79.7,79.7,0,0,0,24.409-9.563,4.427,4.427,0,0,0,1.967-2.755,4.321,4.321,0,0,0-.346-2.928A4.347,4.347,0,0,1,66.313,50.254Z",
    transform: "translate(-9.37 -48.45)",
    fill: "#f0a696"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_11874",
    "data-name": "Path 11874",
    d: "M9.963,62.2V39.469A1.328,1.328,0,0,0,8.634,38.14H3.329A1.342,1.342,0,0,0,2,39.469V62.2a1.328,1.328,0,0,0,1.329,1.329H8.645A1.326,1.326,0,0,0,9.963,62.2Z",
    transform: "translate(-2 -38.14)",
    fill: "#44394a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11875",
    "data-name": "Path 11875",
    d: "M8.645,38.15H6.884V59.123a1.328,1.328,0,0,1-1.329,1.329H2v1.761a1.328,1.328,0,0,0,1.329,1.329H8.645a1.328,1.328,0,0,0,1.329-1.329V39.468A1.34,1.34,0,0,0,8.645,38.15Z",
    transform: "translate(-2 -38.139)",
    fill: "#332b37"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_391",
    "data-name": "Ellipse 391",
    cx: 11.907,
    cy: 11.907,
    r: 11.907,
    transform: "translate(30.504 11.219)",
    fill: "#f8ce01"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11876",
    "data-name": "Path 11876",
    d: "M32.05,30.817A11.9,11.9,0,0,0,51.9,21.957a11.725,11.725,0,0,0-.951-4.657,21.94,21.94,0,0,1-18.9,13.517Z",
    transform: "translate(2.42 1.169)",
    fill: "#f4b601"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6908",
    "data-name": "Group 6908",
    transform: "translate(35.913 16.001)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_392",
    "data-name": "Ellipse 392",
    cx: 2.161,
    cy: 2.161,
    r: 2.161,
    transform: "translate(0.329 0.642)",
    fill: "#e1533b"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_393",
    "data-name": "Ellipse 393",
    cx: 2.161,
    cy: 2.161,
    r: 2.161,
    transform: "translate(8.335 9.297)",
    fill: "#e1533b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6907",
    "data-name": "Group 6907"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11877",
    "data-name": "Path 11877",
    d: "M34.471,29.283a1.075,1.075,0,0,1-.81-1.794L44.476,15.377a1.079,1.079,0,0,1,1.61,1.437l-10.805,12.1a1.056,1.056,0,0,1-.81.367Z",
    transform: "translate(-33.386 -15.016)",
    fill: "#e1533b"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefrrelThree);
export default __webpack_public_path__ + "static/media/refrrel-three.c7c9a81891b95a04b6183ca9be55b37e.svg";
export { ForwardRef as ReactComponent };